import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SocketService } from './socket';
import { CONFIG } from '../config';


@Injectable({
    providedIn: 'root'
})
export class AccountService {

    private _with = [];
    private _withCount = [];

    public user_id = 0;
    private cache = {};


    constructor(private http: HttpClient, private router: Router, private socket: SocketService) {
    }

    isAuth() {
        return localStorage && localStorage.getItem('api_token');
    }

    generateCode(data) {
        let response = this.http.post(CONFIG.url + '/api/v1/auth2/generateCode', data).toPromise();
        return response;
    }

    login(data) {
        let response = this.http.post(CONFIG.url + '/api/v1/auth2/login', data).toPromise();
        response.then(response => {
            localStorage.setItem('api_token', response['api_token']);
            // this.socket.createSocket(response['api_token']);

            // this.http.post(CONFIG.url + 'api/v1/auth/admin/login', { api_token: response['api_token'] }).subscribe(resp2 => {
            //     if (resp2['admin'] == true) {
            //         localStorage.setItem('is_admin', 'true');
            //     }
            //     if (resp2['moder'] == true) {
            //         localStorage.setItem('is_moder', 'true');
            //     }
            //
            //     this.router.navigateByUrl('/');
            // });
            this.router.navigateByUrl('/');
        });
        return response;
    }

    logout() {
        let response = this.http.get(CONFIG.url + '/api/v1/auth/logout', {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (localStorage.getItem('api_token') || '')
            }),
        }).toPromise();
        response.then(() => {
            localStorage.removeItem('api_token');
            this.user_id = 0;
            this.router.navigateByUrl('/auth');
        });
        return response;
    }

    with(relation: string) {
        this._with.push('"' + relation + '"');
        return this;
    }

    withCount(relation: string) {
        this._withCount.push('"' + relation + '"');
        return this;
    }

    get isAdmin() {
        return this.http.get<boolean>(CONFIG.url + '/api/v1/is_admin', {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (localStorage.getItem('api_token') || '')
            })
        });
    }

    get current() {
        if (!this.cache[localStorage.getItem('api_token')]) {

            this.cache[localStorage.getItem('api_token')] = this.http.get(CONFIG.url + '/api/v1/auth/current', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + (localStorage.getItem('api_token') || '')
                })
            }).toPromise();

            this.cache[localStorage.getItem('api_token')].then(user => {
                this.user_id = user['user_id'];
            }, error => {
                localStorage.removeItem('api_token');
                this.router.navigateByUrl('/auth');
            });
        }

        return this.cache[localStorage.getItem('api_token')];
    }
}
